import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { message } from 'antd';

import { BlogCreateEditForm } from 'components/blog/createEdit';

import BlogPostApi from 'api/v2/blog/post';

import _ from 'lodash';

const PostCreateEdit = () => {
  let history = useHistory();
  const { id } = useParams();

  const [content, setContent] = useState({
    section_images: [],
  });

  const fetchPosts = async () => {
    const { data } = await BlogPostApi.getById(id);
    const content = data.data;

    setContent(content);
  };

  const handleContent = (val, key) => {
    if (val) {
      setContent((prevState) => ({
        ...prevState,
        [key]: val,
      }));
    }
  };

  const createData = async (payload) => {
    await BlogPostApi.create(payload);

    message.success(`Successfully created new Post`);

    history.push({
      pathname: '/cms/reviews-and-promos/static-posts',
    });
  };

  const updateData = async (payload) => {
    await BlogPostApi.update(payload);

    message.success(`Successfully updated new Post`);

    history.push({
      pathname: '/cms/reviews-and-promos/static-posts',
    });
  };

  const handleCreateSection = async (section_images) => {
    const payload = {
      url_link: '',
      url_link_mobile: '',
      promotion_title: '',
      section_number:
        section_images.length > 0
          ? section_images[section_images.length - 1].section_number + 1
          : 1,
    };

    try {
      await BlogPostApi.createSection({
        ...payload,
        blog_post_id: Number(id),
      });

      message.success('New section created');
      fetchPosts();
    } catch (err) {
      const errMessage = _.get(err, 'response.data.message');
      message.error(errMessage || 'Cannot connect to the server');
    }
  };

  const handleDeleteSection = async (id) => {
    await BlogPostApi.deleteSection(id);
    fetchPosts();
  };

  const handleUpdateSection = async (payload) => {
    await BlogPostApi.updateSection(payload.id, payload);
  };

  useEffect(() => {
    id && fetchPosts();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <BlogCreateEditForm
      pageName="Post"
      handleCreate={createData}
      handleUpdate={updateData}
      content={content}
      handleContent={handleContent}
      handleCreateSection={handleCreateSection}
      handleUpdateSection={handleUpdateSection}
      handleDeleteSection={handleDeleteSection}
    />
  );
};

export default PostCreateEdit;
